import {
  AlertDialogHeader,
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { FC, useState } from 'react';
import { TruckDetailsForm } from './TruckDetailsForm';
import { useToast } from 'src/components/useToast';
import { trpc } from 'src/trpc';

export const NewTruckModal: FC = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const { successToast, errorToast } = useToast();
  const utils = trpc.useUtils();

  const handleSuccess = () => {
    successToast({
      title: 'Truck created',
      description: 'New truck has been successfully created',
    });
    setOpenDialog(false);
    utils.admin.truck.getAllTrucks.invalidate();
  };

  const handleError = (error: Error) => {
    errorToast({
      title: 'Failed to create truck',
      description: error.message || 'An error occurred while creating the truck',
    });
  };

  return (
    <AlertDialog open={openDialog}>
      <AlertDialogTrigger asChild>
        <div>
          <Button onClick={() => setOpenDialog(true)} className="text-white w-full">
            Create New Truck
          </Button>
        </div>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="text-left text-text-light">
            Create New Truck
          </AlertDialogTitle>
          <div className="mt-4" />
          <TruckDetailsForm
            onSuccess={handleSuccess}
            onError={handleError}
            onStateChange={(state) => setIsFormValid(state.isValid)}
          >
            <div className="flex flex-row justify-end gap-4 mt-4">
              <div>
                <AlertDialogCancel
                  onClick={() => setOpenDialog(false)}
                  className="w-full text-muted mt-0"
                >
                  Cancel
                </AlertDialogCancel>
              </div>
              <div>
                <Button disabled={!isFormValid} className="w-full text-white" type="submit">
                  Create Truck
                </Button>
              </div>
            </div>
          </TruckDetailsForm>
        </AlertDialogHeader>
      </AlertDialogContent>
    </AlertDialog>
  );
};
